<header class="l-header">
  <div class="l-header-panel" style="display: flex; flex-direction: row; justify-content: end; align-items: center;">
    <div style="display: flex; flex-direction: row; justify-content: flex-end;">
      <img
        style="cursor: pointer"
        [matTooltip]="'attendance.common.home' | translate"
        height="41em"
        width="41em"
        src="../../assets/icons/exit.svg"
        (click)="goBack()"
      />
    </div>
  </div>
</header>
<aside class="l-sidebar l-flex l-column" style="height: 100%;display: flex;
    flex-direction: column; justify-content: space-between;">
  <img class="off-mobile sidebar-logo logo-3d-effect" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
    <app-docpanel></app-docpanel>
</aside>
<div class="attendance-tracker-container">
  <!-- Initial Loading Spinner -->
  <div *ngIf="isInitialLoading" class="loading-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <!-- Content (hidden during initial loading) -->
  <div *ngIf="!isInitialLoading">
  <!-- Header -->
  <div class="tracker-header">
      <div class="current-time">{{ currentTime }}</div>
      <h2>{{ 'attendance.tracker.title' | translate }}</h2>
    </div>
    <div class="employee-info" *ngIf="ls.username || ls.ClinicEmployeeNum">
      <span class="employee-name" *ngIf="ls.username">{{ ls.username }}</span>
      <span class="employee-separator" *ngIf="ls.username && ls.ClinicEmployeeNum"> - </span>
      <span class="employee-number" *ngIf="ls.ClinicEmployeeNum">{{ 'attendance.tracker.employeeNumber' | translate }}: {{ ls.ClinicEmployeeNum }}</span>
    </div>

  <!-- Status Display
  <div class="status-section">
    <div [ngClass]="isCheckedIn ? 'status-badge status-checked-in' : 'status-badge status-checked-out'">
      <span class="status-icon">{{ isCheckedIn ? '✓' : '●' }}</span>
      <span class="status-text">{{ isCheckedIn ? 'בעבודה' : 'מחוץ למשמרה' }}</span>
    </div>
  </div> -->

  <!-- Main Button -->
  <div class="button-section">
    <button
      class="check-button"
      [ngClass]="isCheckedIn ? 'check-out-btn' : 'check-in-btn'"
      (click)="doCheckInOut()"
      [disabled]="isLoading || isTodayAbsence()"
      [style.opacity]="isTodayAbsence() ? '0.5' : '1'"
      [style.cursor]="isTodayAbsence() ? 'not-allowed' : 'pointer'"
      [matTooltip]="isTodayAbsence() ? getAbsenceTooltip() : ''"
      matTooltipPosition="below"
      matTooltipClass="absence-tooltip"
    >
      <span *ngIf="!isLoading" class="button-text">
        {{ isCheckedIn ? ('attendance.tracker.checkOut' | translate) : ('attendance.tracker.checkIn' | translate) }}
      </span>
      <mat-spinner *ngIf="isLoading" diameter="24" strokeWidth="3"></mat-spinner>
    </button>
  </div>

  <!-- Reports Buttons -->
  <div class="reports-button-section" style="display: flex; flex-direction: column; gap: 1em; align-items: center;">
    <button class="reports-button" (click)="goToReports()" style="width: 100%; max-width: 280px;">
      <span class="reports-icon">📊</span>
      <span class="reports-text">{{ 'attendance.tracker.monthlyReports' | translate }}</span>
      <span class="arrow-icon">◄</span>
    </button>
    
    <!-- Add Absence Button -->
    <button class="reports-button" style="width: 100%; max-width: 280px;" (click)="openAbsenceModal()">
      <span class="reports-icon">📅</span>
      <span class="reports-text">{{ 'attendance.absence.addButton' | translate }}</span>
      <span class="arrow-icon">◄</span>
    </button>
  </div>

  <!-- Messages -->
  <div *ngIf="successMessage" class="alert alert-success">
    {{ successMessage }}
  </div>
  <div *ngIf="error" class="alert alert-error">
    {{ error }}
  </div>

  <!-- Today's Records -->
  <div class="records-section" *ngIf="todayRecords.length > 0">
    <div class="section-header">
      <div class="section-icon">📋</div>
      <h3>{{ 'attendance.tracker.todayRecords' | translate }}</h3>
    </div>
    <div class="records-list">
      <div *ngFor="let record of todayRecords; let i = index" 
           class="record-card"
           [style.animation-delay]="i * 0.05 + 's'">
        <div class="record-header">
          <div class="record-badge" [ngClass]="record.CheckType === 'check-in' ? 'badge-in' : 'badge-out'">
            <span class="badge-icon">{{ record.CheckType === 'check-in' ? '🟢' : '🔴' }}</span>
            <span class="badge-text">{{ record.CheckType === 'check-in' ? ('attendance.tracker.checkIn' | translate) : ('attendance.tracker.checkOut' | translate) }}</span>
          </div>
          <div class="record-time">
            <span class="time-icon">🕐</span>
            <span class="time-text">{{ formatTime(record.CreationTime) }}</span>
          </div>
        </div>
        <div class="record-details" *ngIf="record.UserName">
          <div class="detail-item">
            <span class="detail-icon">👤</span>
            <span class="detail-text">{{ record.UserName }}</span>
          </div>
        </div>
        <div class="record-footer" *ngIf="record.Location">
          <span class="location-icon">📍</span>
          <span class="location-text">{{ 'attendance.tracker.location' | translate }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- No Records
  <div *ngIf="todayRecords.length === 0" class="no-records">
    <p>אין רשומות להיום</p>
  </div> -->
  </div>
</div>

<!-- Add Absence Modal -->
<div *ngIf="showAbsenceModal" class="print-history-popup" >
  <div class="t-popup-close" (click)="closeAbsenceModal()"></div>
  
  <div class="t-popup-body">
    <button
      class="t-btn-popup-close"
      aria-label="close popup"
      (click)="closeAbsenceModal()"
    ></button>

    <h2 style="color: #d7a95b; text-align: center; margin-bottom: 2em;">
      {{ 'attendance.absence.modalTitle' | translate }}
    </h2>

    <div style="margin: 2em 0;">
      <!-- Start Date -->
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 1em;">
        <label style="color: #277382; min-width: 100px;">
          {{ 'attendance.absence.startDate' | translate }}
        </label>
        <i class="t-sep"></i>
        <input
          type="date"
          [(ngModel)]="absenceForm.startDate"
          class="t-field-text"
          style="text-align: center; flex: 1;"
        />
      </div>

      <!-- End Date -->
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 1em;">
        <label style="color: #277382; min-width: 100px;">
          {{ 'attendance.absence.endDate' | translate }}
        </label>
        <i class="t-sep"></i>
        <input
          type="date"
          [(ngModel)]="absenceForm.endDate"
          class="t-field-text"
          style="text-align: center; flex: 1;"
        />
      </div>

      <!-- Absence Type -->
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 1em;">
        <label style="color: #277382; min-width: 100px;">
          {{ 'attendance.absence.type' | translate }}
        </label>
        <i class="t-sep"></i>
        <select
          [(ngModel)]="absenceForm.absenceType"
          class="t-select"
          style="flex: 1;"
        >
          <option value="vacation">{{ 'attendance.absence.vacation' | translate }}</option>
          <option value="sick">{{ 'attendance.absence.sick' | translate }}</option>
        </select>
      </div>

      <!-- Reason -->
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 1em;">
        <label style="color: #277382; min-width: 100px;">
          {{ 'attendance.absence.reason' | translate }}
        </label>
        <i class="t-sep"></i>
        <textarea
          [(ngModel)]="absenceForm.reason"
          class="t-field-text"
          style="flex: 1; min-height: 60px; resize: vertical;"
          [placeholder]="'attendance.absence.reasonPlaceholder' | translate"
        ></textarea>
      </div>
    </div>

    <div *ngIf="absenceError" style="color: #d9534f; text-align: center; margin: 1em 0; font-weight: 600;">
      {{ absenceError }}
    </div>

    <div class="l-flex l-flex-w t-fieldmargin patient-details" style="gap: 0.75rem; display: flex; justify-content: space-evenly; margin-top: 2em;">
      <button
        class="search-btn"
        style="width: 6em"
        [disabled]="isAbsenceSaving || !absenceForm.startDate || !absenceForm.endDate || !absenceForm.absenceType"
        (click)="saveAbsence()"
      >
        <mat-spinner *ngIf="isAbsenceSaving" diameter="18" strokeWidth="3" class="spinner-white" style="margin-right: 0.75rem;"></mat-spinner>
        <span *ngIf="!isAbsenceSaving">{{ 'attendance.modal.save' | translate }}</span>
      </button>

      <button
        class="search-btn"
        style="width: 6em; background: #888"
        [disabled]="isAbsenceSaving"
        (click)="closeAbsenceModal()"
      >
        {{ 'attendance.modal.cancel' | translate }}
      </button>
    </div>
  </div>
</div>
